import { ApiResult, urlMaker } from '@shared/utils';
import { CounterMappers } from '../mappers';
import { Counter } from '../types';
import { translate } from '@infra/i18n/i18n';

export class CounterService {
  public static async get(): Promise<ApiResult<200, Counter> | ApiResult<400 | 500, string>> {
    const url = urlMaker('/api/warehouse/notification/count');

    try {
      const response = await this.caller(url, { method: 'POST' });

      if (response.ok) {
        const data = await response.json();
        const mappedData = CounterMappers.fromApi(data);

        return new ApiResult(200, mappedData, null);
      } else {
        return new ApiResult(400, translate('common.errors.operationFailed'), null);
      }
    } catch (e) {
      return new ApiResult(500, translate('common.errors.networkFailed'), null);
    }
  }
}
